import { createStore } from 'vuex'
import home from './home'
import userInfo from './userInfo'
import menu from './menu'
import open from './open'
import searchbar from './searchbar'
// 第一步：实例化store，这里没有app、没有Vue.use
const store = createStore({
    modules:{
        home,
        userInfo,
        menu,
        open,
        searchbar
    }
})
export default store